"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var styled_components_1 = require("styled-components");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var palette_1 = require("../constants/palette");

var Box_1 = require("./Box"); // TODO: Deprecate


var StyledTextWithIconContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: row;\n  font-size: 13px;\n  line-height: 16px;\n  color: ", "\n  .icon-left {\n    width: 20px;\n  }\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: row;\n  font-size: 13px;\n  line-height: 16px;\n  color: ", "\n  .icon-left {\n    width: 20px;\n  }\n"])), function (props) {
  return props.light ? '#777777' : palette_1.default.black;
});
console.warn('TextWithIcon is deprecated. Please use Media instead.');

var TextWithIcon = function TextWithIcon(props) {
  return React.createElement(StyledTextWithIconContainer, __assign({}, props), React.createElement(Box_1.default, {
    textAlign: "center",
    className: "icon-left"
  }, React.createElement(react_fontawesome_1.FontAwesomeIcon, {
    icon: props.icon,
    color: "#e6e6e6"
  })), React.createElement(Box_1.default, {
    ml: 2
  }, props.children));
};

exports.default = TextWithIcon;
var templateObject_1;